import { Injectable } from '@angular/core';

import { UrlParam } from '@frontend/sports/navigation/core/feature/url-builder';
import { CouponUrlParam, UrlHelperService } from '@frontend/sports/navigation/core/feature/url-helper';

import { Coupon, CouponType } from './coupon.model';

@Injectable({ providedIn: 'root' })
export class CouponsUtilsService {
    constructor(private urlHelper: UrlHelperService) {}

    getUrl(coupon: Coupon, sport: UrlParam, region?: UrlParam, league?: UrlParam): string {
        const isCompetitionCoupon = !!(region && league);

        // coupon title was undefined on qa
        if (!coupon.title && !isCompetitionCoupon) {
            return this.urlHelper.getCouponUrl(sport);
        }

        const param = coupon.id === CouponType.BetBuilder ? CouponUrlParam.BetBuilder : { id: coupon.id, name: coupon.title };

        return isCompetitionCoupon ? this.urlHelper.getCompetitionCouponUrl(sport, param, region, league) : this.urlHelper.getCouponUrl(sport, param);
    }
}
